import { render, staticRenderFns } from "./SetServiceData.vue?vue&type=template&id=74928c46&scoped=true&"
import script from "./SetServiceData.vue?vue&type=script&lang=js&"
export * from "./SetServiceData.vue?vue&type=script&lang=js&"
import style0 from "./SetServiceData.vue?vue&type=style&index=0&id=74928c46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74928c46",
  null
  
)

export default component.exports